export default __webpack_public_path__ + "static/media/qufus_logo_light.a640d51a.png";